module.exports = __webpack_public_path__ + "front/img/1.8201be62.jpg";